module.exports = __webpack_public_path__ + "static/img/fingerpost_refund_5.6a68f1d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fingerpost/fingerpost_refund_5.jpg
// module id = 8kIx
// module chunks = 0